import { default as React, ReactNode, useEffect, useMemo, useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedDate, FormattedNumber, injectIntl } from "react-intl"
import { useQuery } from "react-query"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { StatusBadge } from "../../../common/badge"
import Icon from "../../../common/icon/icon.component"
import SideBar from "../../../common/layout/sidebar.component"
import StandardList from "../../../common/listing/list.component"
import Pagination from "../../../common/listing/pagination.component"
import LoadingSpinner from "../../../common/spinner/loading.component"
import { NewStockMovementModal } from "../../../inventory/modals"
import { PropsType } from "../../../state/contact/models"
import {
    InventoryStockDocumentDefinitionAction,
    InventoryStockDocumentDefinitionSelector,
} from "../../../state/inventory"
import { StockDocumentElastic } from "../../../state/listing/inventory/models"
import SearchService from "../../../state/search/SearchService"
import { generateStockDocumentSearchParams } from "../../../utils"
import { CONTACT_TYPE, SUPPLIER_DETAILS_MESSAGES } from "../../../utils/contacts"
import { INVENTORY_STOCK_DIRECTION } from "../../../utils/inventory"
import CustomerInfoView from "../../info.component"


const SupplierDetails = (props: PropsType) => {
    const supplierId = props.match.params.supplierId
    const stockDocumentDefinitions = useSelector(InventoryStockDocumentDefinitionSelector.get)
    const [activeDefinitionId, setActiveDefinitionId] = useState<string>("")
    const [modal, setModal] = useState<ReactNode>()
    const [activePage, setActivePage] = useState<number>(1)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!stockDocumentDefinitions.isLoaded && !stockDocumentDefinitions.isFetching) {
            dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
        }

        SideBar.activateMenu("contact")
    }, [])


    const tabs = stockDocumentDefinitions.listing
        .filter((item) => item.direction != INVENTORY_STOCK_DIRECTION.IN_OUT)
        .map((item, i) => {
            if (!activeDefinitionId && i === 0) {
                setActiveDefinitionId(item.id)
            }
            return (
                <>
                    <li className="nav-item">
                        <a className={`nav-link btn ${activeDefinitionId === item.id ? "active" : ""}`} href="#"
                            onClick={() => {
                                if (activeDefinitionId === item.id) {
                                    return
                                }
                                setActivePage(1)
                                setActiveDefinitionId(item.id)
                            }}>
                            <h6 className="mb-0">
                                <span>{item.name}</span>
                            </h6>
                        </a>
                    </li>
                </>
            )
        })

    const {
        isLoading,
        data
    } = useQuery(["stock-document-listing", activeDefinitionId, supplierId, activePage],
        () => SearchService.mainSearch<StockDocumentElastic>(
            generateStockDocumentSearchParams({
                pageSize: 10,
                activePage: activePage,
                filters: {
                    "contact.id": supplierId,
                    "definitionId": activeDefinitionId,
                }
            })))

    const headers = [
        props.intl.formatMessage(SUPPLIER_DETAILS_MESSAGES.header_id),
        props.intl.formatMessage(SUPPLIER_DETAILS_MESSAGES.header_value),
        props.intl.formatMessage(SUPPLIER_DETAILS_MESSAGES.header_created_at),
        props.intl.formatMessage(SUPPLIER_DETAILS_MESSAGES.header_status),
    ]

    const openCreateModal = () => {
        setModal(<NewStockMovementModal
            supplierId={supplierId}
            definitionId={activeDefinitionId}
            onCloseCallback={() => setModal(undefined)}
        />)
    }

    const currentlySelectedDefinition = useMemo(() => {
        return stockDocumentDefinitions.listing.find(item => item.id === activeDefinitionId)
    }, [activeDefinitionId])

    const rows = data?.data?.map(item => {
        return [
            <Link key={"id"} to={`/stock-documents/${item.id}/edit`}>{item.identifier}</Link>,
            <FormattedNumber key={"total"} style="currency" currency={item.currency} value={item.totalAmount}/>,
            <FormattedDate key={"date"} year="numeric" month="long" day="numeric" value={new Date(item.createdAt)}/>,
            <StatusBadge key={"status"} colorCode={item.statusObj.colorCode} text={item.statusObj.name}/>,
        ]
    }) ?? []

    return (
        <>
            {modal}
            <CustomerInfoView apiObject={CONTACT_TYPE.SUPPLIER} value={supplierId} className="ui-has-modules"/>

            <ul className="nav nav-tabs">
                {tabs}
            </ul>

            {isLoading ?
                <LoadingSpinner/> :
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={headers}
                    rows={rows}
                    footer={
                        <div className={"d-flex justify-content-between"}>
                            <Pagination
                                activePage={activePage}
                                pageSize={2}
                                totalItemsCount={data?.metadata.totalItemsCount ?? 0}
                                onChange={p => setActivePage(p)}
                            />
                            <div className={"mt-1"}>
                                <Button onClick={openCreateModal} size={"sm"}>
                                    <Icon value="plus-circle" className={"mr-1"}/>
                                    {props.intl.formatMessage(SUPPLIER_DETAILS_MESSAGES.button_create)}&nbsp;
                                    {currentlySelectedDefinition?.name}
                                </Button>
                            </div>
                        </div>
                    }
                />
            }
        </>
    )
}
export default injectIntl(SupplierDetails)


// WEBPACK FOOTER //
// ./src/customer/supplier/components/SupplierDetails.tsx